import { render, staticRenderFns } from "./ed-courses.vue?vue&type=template&id=40083068&scoped=true&"
import script from "./ed-courses.ts?vue&type=script&lang=ts&"
export * from "./ed-courses.ts?vue&type=script&lang=ts&"
import style0 from "./ed-courses.scss?vue&type=style&index=0&id=40083068&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40083068",
  null
  
)

export default component.exports